import validate from 'validate.js'
import firebase from 'firebase/app'
import 'firebase/auth'
import { useTEPopupsFunctions } from 'react-tec'

interface ResetPasswordData {
	password: string
	actionCode: string | null
	popupFunctions: useTEPopupsFunctions
}
export const resetPassword = async (data: ResetPasswordData) => {
	const { password, actionCode, popupFunctions } = data
	const { showAlert, showNetworkActivity, hideNetworkActivity } = popupFunctions

	//Validate Data
	const validatorConstraints: {[key:string]:any} = {
		password: {
			presence: {
				allowEmpty: false,
			},
		},
	}
	const validationResponse = validate(data, validatorConstraints)
	if (validationResponse) {
		const valuesArray: any[][] = Object.values(validationResponse)
		const firstError: any[] = valuesArray[0]
		const firstErrorMessage: string = firstError[0]
		showAlert({
			title: 'Error',
			message: firstErrorMessage,
		})
		return
	}

	if (!actionCode) {
		showAlert({
			title: 'Error',
			message: 'No valid Action Code.',
		})
		return
	}
	try {
		showNetworkActivity('Resetting Password...')
		await firebase.auth().verifyPasswordResetCode(actionCode)
		await firebase.auth().confirmPasswordReset(actionCode, password)
		hideNetworkActivity()
		showAlert({
			title: 'Success',
			message: 'Your password has been reset.',
		})
		return
	} catch (e) {
		console.log(e)
		hideNetworkActivity()
		showAlert({
			title: 'Error',
			message: 'Error Resetting Password.',
		})
		return
	}
}
interface RecoverEmailData {
	actionCode: string | null
	popupFunctions: useTEPopupsFunctions
}
export const recoverEmail = async (data: RecoverEmailData) => {
	const { actionCode, popupFunctions } = data
	const { showAlert, showNetworkActivity, hideNetworkActivity } = popupFunctions

	if (!actionCode) {
		showAlert({
			title: 'Error',
			message: 'No valid Action Code.',
		})
		return
	}
	try {
		showNetworkActivity('Recovering Email...')
		const info = await firebase.auth().checkActionCode(actionCode)
		const recoverEmail = info.data.email
		if (recoverEmail) {
			await firebase.auth().applyActionCode(actionCode)
			await firebase.auth().sendPasswordResetEmail(recoverEmail)
			hideNetworkActivity()
			showAlert({
				title: 'Success',
				message:
					'Your email address has been recovered. For security we have also sent a password reset email.',
			})
		} else {
			hideNetworkActivity()
			showAlert({
				title: 'Error',
				message: 'Error Recovering Email.',
			})
		}
	} catch (e) {
		console.log(e)
		hideNetworkActivity()
		showAlert({
			title: 'Error',
			message: 'Error Recovering Email.',
		})
	}
}
interface VerifyEmailData {
	actionCode: string | null
	popupFunctions: useTEPopupsFunctions
}
export const verifyEmail = async (data: VerifyEmailData) => {
	const { actionCode, popupFunctions } = data
	const { showAlert, showNetworkActivity, hideNetworkActivity } = popupFunctions

	if (!actionCode) {
		showAlert({
			title: 'Error',
			message: 'No valid Action Code.',
		})
		return
	}
	try {
		showNetworkActivity('Verifying Email...')

		await firebase.auth().applyActionCode(actionCode)
		hideNetworkActivity()
		showAlert({
			title: 'Success',
			message: 'Your email has been verified.',
		})
	} catch (e) {
		console.log(e)
		hideNetworkActivity()
		showAlert({
			title: 'Error',
			message: 'Error Verifying Your Email.',
		})
	}
}
